import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useLocale } from '../contexts/LocaleContext'

function Footer() {
  const [year, setYear] = useState('')
  const { locale, t } = useLocale()
  
  useEffect(() => setYear(String(new Date().getFullYear())), [])

  const getLocalizedPath = (page) => {
    return locale === 'fr' ? `/fr/${page}` : `/${page}`
  }

  return (
    <footer role="contentinfo">
      <div className="container row">
        <div>{t.footer.copyright.replace('{year}', year)}</div>
        <div>
          <a href={getLocalizedPath('privacy.html')}>{t.footer.privacy}</a> · <a href={getLocalizedPath('terms.html')}>{t.footer.terms}</a> · <Link to={getLocalizedPath('contact')}>{t.footer.contact}</Link>
        </div>
      </div>
    </footer>
  )
}

export default Footer
